import * as React from "react"
export const Svg_068 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M53.29 8.155H59V4.698h-4.698V.001h-3.457v5.71l-1.703 1.702 2.444 2.445 1.703-1.703Z"
      />
      <path
        fill="url(#c)"
        d="M19.59 29.5c0 5.464 4.446 9.91 9.91 9.91s9.91-4.446 9.91-9.91c0-2.11-.662-4.067-1.79-5.675l-6.898 6.897-2.444-2.444 6.897-6.898a9.855 9.855 0 0 0-5.675-1.79c-5.464 0-9.91 4.446-9.91 9.91Z"
      />
      <path
        fill="url(#d)"
        d="m51.547 9.898-4.495 4.494A23.07 23.07 0 0 1 52.67 29.5c0 12.775-10.394 23.169-23.169 23.169S6.331 42.275 6.331 29.5 16.724 6.331 29.5 6.331a23.07 23.07 0 0 1 15.108 5.617l4.494-4.495C43.697 2.634 36.801 0 29.5 0 21.62 0 14.212 3.069 8.64 8.64 3.07 14.212 0 21.62 0 29.5c0 7.88 3.069 15.288 8.64 20.86C14.212 55.931 21.62 59 29.5 59c7.88 0 15.288-3.069 20.86-8.64C55.93 44.787 59 37.38 59 29.5c0-7.3-2.634-14.197-7.453-19.602Z"
      />
      <path
        fill="url(#e)"
        d="M9.788 29.5c0 10.87 8.843 19.712 19.712 19.712 10.87 0 19.712-8.843 19.712-19.712 0-4.814-1.735-9.23-4.611-12.657l-4.51 4.51a13.3 13.3 0 0 1 2.776 8.147c0 7.37-5.996 13.367-13.367 13.367-7.37 0-13.367-5.996-13.367-13.367 0-7.37 5.996-13.367 13.367-13.367a13.3 13.3 0 0 1 8.146 2.776l4.51-4.51A19.624 19.624 0 0 0 29.5 9.788C18.63 9.788 9.788 18.63 9.788 29.5Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={51.422}
        x2={56.104}
        y1={1.479}
        y2={9.057}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={24.173}
        x2={33.588}
        y1={22.563}
        y2={37.8}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={13.644}
        x2={41.669}
        y1={8.85}
        y2={54.206}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={18.905}
        x2={37.631}
        y1={15.701}
        y2={46.009}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h59v59H0z" />
      </clipPath>
    </defs>
  </svg>
)